module.exports = __webpack_public_path__ + "static/media/home-dashboard.40b4b289.png";